const CLIENT_ID = '130884198718-a1g7f8dtastlrdv1lk0jsi8e3qivu9ms.apps.googleusercontent.com'; // Dima -> '46124830198-0dcsa7ciimbqbtcusn5me9np78k86d34.apps.googleusercontent.com';
const REDIRECT_URI = 'https://339f7d-44.myshopify.com/cart'; //TODO: Change url
const SCOPES = 'https://www.googleapis.com/auth/drive.file';

addEventListener("DOMContentLoaded", (event) => {
    const preSubmitBtn = document.getElementById('presubmit');
  
    preSubmitBtn.addEventListener('click', async function(e) {
      await uploadFileWithAuth();
  });
});

function openAuthPopup(authUrl) {
    return new Promise((resolve, reject) => {
        const authWindow = window.open(authUrl, '_blank', 'rel=noopener');
        const interval = setInterval(() => {
            try {
                if (authWindow.closed) {
                    clearInterval(interval);
                    reject(new Error('User closed the popup window'));
                }

                const url = new URL(authWindow.location);
                if (url.hash.includes('access_token')) {
                    const urlParams = new URLSearchParams(url.hash.substring(1));
                    const accessToken = urlParams.get('access_token');
                    
                    authWindow.close();

                    clearInterval(interval);
                    resolve(accessToken);
                }
            } catch (error) {
                // Ignore cross-origin errors
            }
        }, 1000);
    });
}


async function uploadFileWithAuth() {
    try {
      const authUrl = `https://accounts.google.com/o/oauth2/auth?client_id=${CLIENT_ID}&redirect_uri=${encodeURIComponent(REDIRECT_URI)}&response_type=token&scope=${encodeURIComponent(SCOPES)}`; 
      const accessToken = await openAuthPopup(authUrl);
      console.log(accessToken);
      if (accessToken) {
         const checkoutBtn = document.getElementById('checkout');
         const table = document.getElementById('cart-items-table');
         const rows = table.getElementsByTagName('tr');
         for (let i = 1; i < rows.length; i++) {
            const fileInputId = insertIdentifier(rows[i], "cart-item_uploadFile");
            const messageInputId = insertIdentifier(rows[i], "cart-item_description");
            console.log(fileInputId);
            console.log(messageInputId);
            const fileInput =  document.getElementById(fileInputId);
            const messageInput =  document.getElementById(messageInputId);
            if(fileInput && messageInput){
                const file = fileInput.files[0];
                const message = messageInput.value;
                if(file){
                  await uploadFile(accessToken, fileInputId, file, message);
               }
            }
         }
         checkoutBtn.click();
      }
    } catch (error) {
        console.error('Error during authentication or upload:', error);
        alert('Failed to upload file.');
    }
}

function insertIdentifier(row, identifier) {
   for (const cell of row.cells) {
      if (cell.classList.contains(identifier)) {
            const firstChild = cell.firstElementChild;
            if (firstChild && firstChild.id) {
              return firstChild.id;
          }
      }
   }
}

async function uploadFile(accessToken, fileInputId, file, message) {
    const metadata = {
        name: fileInputId + ' ' + file.name,
        mimeType: file.type,
        description: message
    };

    const formData = new FormData();
    formData.append('metadata', new Blob([JSON.stringify(metadata)], { type: 'application/json' }));
    formData.append('file', file);

    try {
        const response = await fetch('https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart', {
            method: 'POST',
            headers: new Headers({
                'Authorization': 'Bearer ' + accessToken,
            }),
            body: formData,
        });

        const result = await response.json();

        /* if (response.ok && result.id) {
            alert('File uploaded successfully! File ID: ' + result.id);
        } else {
            console.error('Error uploading file:', result);
            alert('Failed to upload file.');
        } */
    } catch (error) {
        console.error('Error:', error);
        alert('Failed to upload file.');
    }
}
